module.exports = __webpack_public_path__ + "media/images/winery-header-m-66d3377c12d2bb6bba8d1761fc9bb71a.jpg";